export default __webpack_public_path__ + "static/gilat-rash-124bd7e5e36c74265cd98ece4028f194.png";